import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ModificationCommonService } from '../../services/modification-common.service';
import { CommonModule, DatePipe } from '@angular/common';
import { ConstantService } from '../../services/constant.service';
import { UtilService } from '../../services/util.service';
import { UploadedProofComponent } from '../uploaded-proof/uploaded-proof.component';
import { MaterialModule } from '../../material.module';



@Component({
  selector: 'app-income-proof-next-step',
  imports: [MaterialModule,CommonModule],
  templateUrl: './income-proof-next-step.component.html',
  styleUrl: './income-proof-next-step.component.less'
})
export class IncomeProofNextStepComponent {
  @ViewChild('fileUpload1') fileUpload1!: ElementRef;
  @ViewChild('fileUpload2') fileUpload2!: ElementRef;

  appSource! : string | null
  subSource! : string | null
  clientCode! : string | null
  ipAddress!: string;
  fileErrorMessage!:string;
  isPdfFile: boolean = false;
  capturedImage!:any;
  proofSource!:any;
  proofCode: number;
  upload1Event: any;
  upload2Event: any;
  uploadProof2Show = false;
  fileFormat = '';
  format1 = '';
  format2 = '';
  txtContant = '';
  do_1 = '';
  //accept = '.jpg, .jpeg, .bmp, .pdf , .png';
  accept = '.pdf';
  display=false;
  timer=10000;
  htmlTxt: any = {};
  message: any;
  interval!: any;
  currentDate!: string;

  constructor(
      @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
      private _bottomSheetRef: MatBottomSheetRef<IncomeProofNextStepComponent>,
      private modificationCommonService: ModificationCommonService,
      private datePipe: DatePipe,
      private _bottomSheet: MatBottomSheet,
      private constantService: ConstantService,
      private utilService: UtilService
  ) {
      this.appSource = localStorage.getItem(this.constantService.localStorageElement.appSource);
      this.subSource = localStorage.getItem(this.constantService.localStorageElement.subSource);
      this.clientCode = localStorage.getItem(this.constantService.localStorageElement.clientCode);
      this.updateDateRange();
      this.proofCode = data.value;
      this.txtContant = this.htmlTxt[this.proofCode].headContant;
      this.do_1 = this.htmlTxt[this.proofCode].do_1;
      this.message = this.htmlTxt[this.proofCode].message;
      this.uploadProof2Show = false;
      this.startInterval();
     
      
  }

  ngOnDestroy() {
      clearInterval(this.interval);
    }
  startInterval() {
      this.interval = setInterval(() => {
        this.display = !this.display;
        clearInterval(this.interval);
        this.timer = this.display ? 3000 : 10000;
        this.startInterval();
      }, this.timer);
    }
  async ngOnit() {
   
  }

  uploadBankStatement(event: any, type: string = 'upload1') {
      const file: File = <File>event.target.files[0];
      this.fileFormat = file.type;
      if (file.type.includes('/pdf')) {
          this.isPdfFile = true;
      } else {
          this.isPdfFile = false;
      }
      const fileSize = file.size / 1024;
      if (fileSize > 10240) {
          this.fileErrorMessage = 'File size should not be more than 10 MB.';
          return;
      } else {
          if (
              file.type.includes('image/jpg') ||
              file.type.includes('image/jpeg') ||
              file.type.includes('image/png') ||
              file.type.includes('image/bmp') ||
              file.type.includes('/pdf')
          ) {
              if (type == 'upload1') {
                  this.upload1Event = event;
                  this.format1 = this.fileFormat;
              } else if (type == 'upload2') {
                  this.upload2Event = event;
                  this.format2 = this.fileFormat;
              }
              if (this.upload1Event != null && !this.uploadProof2Show) {
                  this._bottomSheet.open(UploadedProofComponent, {
                      data: { 
                        proof1: this.upload1Event, 
                        format1: this.format1, 
                        proofType: this.txtContant,
                        proofCode: this.proofCode
                    }
                  });
              } else if (this.upload1Event != null && this.upload2Event != null) {
                  this._bottomSheet.open(UploadedProofComponent, {
                      data: {
                          proof1: this.upload1Event,
                          proof2: this.upload2Event,
                          format1: this.format1,
                          format2: this.format2,
                          proofType: this.txtContant,
                          proofCode: this.proofCode
                      }
                  });
              }
          }
      }
  }

  formatDate(date: Date): string {
      const options = { year: 'numeric', month: 'short' } as const;
      return date.toLocaleDateString('en-US', options);
    }
    updateDateRange(): void {
      const currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let nextYear = currentYear + 1;
      
      // Adjust AY based on the month
      let ayCurrentYear = currentYear;
      let ayNextYear = nextYear;
      
      if (currentDate.getMonth() < 3) { // January, February, March
          ayCurrentYear = currentYear - 1;
          ayNextYear = currentYear;
      }
      
      // Get current month and date
      const currentMonth = currentDate.toLocaleString('default', { month: 'long' });
      const currentDay = currentDate.getDate()-1;
      
      // Calculate previous month with its correct year
      const previousMonthDate = new Date(currentDate);
      previousMonthDate.setMonth(currentDate.getMonth() - 1);
      const previousMonth = previousMonthDate.toLocaleString('default', { month: 'long' });
      const previousMonthYear = previousMonthDate.getFullYear();
// Add 6 months to the current date
const fixDepositDate = new Date(currentDate);
fixDepositDate.setMonth(currentDate.getMonth() + 6);

// Get the long month name for fix deposit date
const fixDepositMonth = fixDepositDate.toLocaleString('default', { month: 'long' });
     this.htmlTxt = {

    '17': {

        headContant: '<h5>Income Tax Return (ITR)</h5>',

        do_1: 'Latest ITR',

        message: `ITR acknowledgement for the latest assessment year. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '22': {

        headContant: '<h5>Bank Statement</h5>' + '<span>(last 6 months)</span>',

        do_1: 'Latest 6 month bank statement',

        message: `Bank statement for the last 6 months. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '23': {

        headContant: '<h5>Demat Holding</h5>',

        do_1: 'Broker name & DP ID should be clear',

        message: `Statement of demat holdings with current holdings details. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '71': {

        headContant: '<h5>Fixed Deposit</h5>',

        do_1: 'FD should mature at least after 6 month.',

        message: `Fixed Deposit statement with maturity details. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '18': {

        headContant: '<h5>Copy of Annual</h5>' + '<h5>Accounts</h5>',

        do_1: 'If the incorporation date is greater than 2 years, upload balance sheet or profit and loss statement',

        message: `Latest Balance Sheet or Profit & Loss Statement. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '19': {

        headContant: '<h5>Form 16</h5>',

        do_1: 'Latest form 16',

        message: `Latest Form 16 for the applicable assessment year. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '20': {

        headContant: '<h5>Net-worth</h5>' + '<h5>Certificate</h5>',

        do_1: "On CA's letterhead with stamp & signature",

        message: `Latest Net Worth Certificate. (${currentDay} ${currentMonth} ${currentYear})`

    },
 
    '21': {

        headContant: '<h5>Salary Slip</h5>',

        do_1: 'Company name & month should be clear',

        message: `Latest month salary slip. (${currentDay} ${currentMonth} ${currentYear})`

    }

};
 
    }

}
